import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Typography, Card, CardContent, CardMedia, Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface IProps {
  title: string;
  description?: string | null;
  children?: ReactNode;
  iconUrl: string;
  withArrow?: boolean;
  path: string | null;
}

const InfoCard: React.FC<IProps> = ({
  title,
  description,
  iconUrl,
  withArrow = false,
  path,
  children,
}) => {
  return (
    <Card
      component={path ? Link : "div"}
      {...(path && { to: path })}
      variant="outlined"
      sx={{
        display: "block",
        border: "none",
        boxSizing: "border-box",
        bgcolor: "background.default",
        textDecoration: "none",
        borderRadius: "20px",
        padding: { xs: 2, md: 3, lg: 4 },
        height: "100%",
      }}
    >
      <CardMedia
        component="img"
        image={iconUrl}
        alt={title}
        sx={{
          width: { xs: 24, md: 40 },
          height: { xs: 24, md: 40 },
          mb: { xs: 2, md: 4 },
        }}
      />

      {/* Description */}
      <CardContent sx={{ padding: "0 !important" }}>
        <Box
          mb={{ xs: 1, md: 2 }}
          display="flex"
          alignItems="center"
          gap={1}
          sx={{
            "& svg": {
              width: 12,
              height: 12,
            },
          }}
        >
          <Typography variant="h4" component="h3" color="text.primary">
            {title}
          </Typography>
          {withArrow && (
            <ArrowForwardIosIcon
              fontSize="small"
              sx={{ color: "text.accent" }}
            />
          )}
        </Box>
        <Typography
          variant="body1"
          color="text.secondary"
          fontSize={{ sm: 16, md: 18 }}
        >
          {children && children}
          {description && description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
